<template>
  <div class="newDtail">
    <nav-header />
    <div class="contents">
      <div class="title-top">
        <div class="title">
          <span class="time">{{ Factorys.createtime }}</span>
          <span class="line">─────</span>
          <span class="admin">Admin</span>
          <span class="views">{{ Factorys.views }}</span>
        </div>
        <div class="title_text">{{ Factorys.title }}</div>
      </div>

      <div class="maincontent">
        <div class="body">
          <div class="le">
            <div class="p-share">
              <div class="share-t" style="width: 88px;">
                Share
              </div>
              <div class="share-t" @click="goView('https://facebook.com/')">
                <img src="../assets/img/f1.png" style="width: 58%;height: auto;"></img>
              </div>
              <div class="share-t" @click="goView('https://www.instagram.com/')">
                <img src="../assets/img/in.png" style="width: 58%;height: auto;"></img>
              </div>
              <div class="share-t" @click="goView('https://twitter.com/')">
                <img src="../assets/img/twiter.png" style="width: 58%;height: auto;"></img>
              </div>
              <div class="share-t" @click="goView('https://www.skype.com/')">
                <img src="../assets/img/skype-3.png" style="width: 58%;height: auto;"></img>
              </div>
              <div class="share-t" @click="goView('https://web.wechat.com/')">
                <img src="../assets/img/wechat.png" style="width: 58%;height: auto;"></img>
              </div>
            </div>
            <div v-html="Factorys.maincontent" style="line-height: 30px"></div>
            <div class="p-con">
              <div class="p-b-s">
                <div class="p-le"  @click="goWindowPages(Prevnews[0].id)">
                  <div class="line"></div>
                  <div class="arrow-le"></div>
                  <div class="arrow-texts">Prev</div>
                  <div class="arrow-text">Prev：{{ Prevnews[0].title }}</div>
                </div>
                <div class="p-ri" @click="goWindowPages(Nextnews[0].id)">
                  <div class="arrow-le"></div>
                  <div class="arrow-texts">Next</div>
                  <div class="arrow-text">Next：{{ Nextnews[0].title }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="ri">
            <div class="p-share">
              <div class="share-t" style="width: 88px;">
                Share
              </div>
              <div class="share-t" @click="goView('https://facebook.com/')">
                <img src="../assets/img/f1.png" style="width: 68%;height: auto;"></img>
              </div>
              <div class="share-t" @click="goView('https://www.instagram.com/')">
                <img src="../assets/img/in.png" style="width: 68%;height: auto;"></img>
              </div>
              <div class="share-t" @click="goView('https://twitter.com/')">
                <img src="../assets/img/twiter.png" style="width: 68%;height: auto;"></img>
              </div>
              <div class="share-t" @click="goView('https://www.skype.com/')">
                <img src="../assets/img/skype-3.png" style="width: 68%;height: auto;"></img>
              </div>
              <div class="share-t" @click="goView('https://web.wechat.com/')">
                <img src="../assets/img/wechat.png" style="width: 68%;height: auto;"></img>
              </div>
            </div>
            <div class="hotnews">
              <div class="items" v-for="(val, index) in hotnews" :key="index" @click="goWindowPages(val.id)">
                <div class="times">{{ val.createtime }}</div>
                <div class="title">{{ val.title }}</div>
                <div class="text">{{ val.description }}</div>
                <div class="slide-mores">
                  <div class="slide-more ">View More</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <nav-footer />
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import NavHeader from "@/components/NavHeaders.vue";
import NavFooter from "@/components/NavFooter.vue";
import "swiper/css/swiper.css";
export default {
    name: "product-newdetail",
    data() {
        return {
            a: '',
            id: this.$route.params.id,
            Factorys: {

            },
            hotnews:[
             {}, {}, {}
            ],
            Prevnews:[
                {'title':''}
            ],
            Nextnews:[
            {'title':''}
            ],
            current_page: '',
            total: '',
            news: [
                {}, {}, {}
            ],

        };
    },
    components: {
        NavHeader,
        NavFooter,
        Swiper,
        SwiperSlide,
    },
    mounted() { },
    created() {
        let self = this;
        document.documentElement.scrollTop = "0px";
        self.init();
        self.getProductLists();
    },
    methods: {
        backs() {
            history.go(-1);
        },
        goWindowPages(val){
          window.open('http://yingcheng.0576hs.com/#/eventsDetail/'+val)
        },
        getProductLists() {
            let id = '26';
            this.currentPage = 1
            this.$api.mall.getEvents({ limit: 3, page: 1 }).then((res) => {
                this.hotnews = res.data.data.data;
                this.current_page = res.data.data.current_page
                this.total = res.data.data.total
            });
        },
        getPrevProductList() {
            let id = '26';
            this.currentPage = 1
            this.$api.mall.getEvents({ limit: 1, page: 1 }).then((res) => {
                this.Prevnews = res.data.data.data;
                this.current_page = res.data.data.current_page
                this.total = res.data.data.total
            });
        },
        getNextProductList() {
            let id = '26';
            this.currentPage = 1
            this.$api.mall.getEvents({ limit: 1, page: 2 }).then((res) => {
                if(res.data.data.data.length){
                  this.Nextnews = res.data.data.data
                }
                this.current_page = res.data.data.current_page
                this.total = res.data.data.total
            });
        },
        init() {
            let self = this;
            // console.log(self);
            this.$api.mall
                .getEventsdetail({
                    id: self.id,
                })
                .then((ress) => {
                    let res = ress.data.data;
                    //console.log(res, "Ssbbb");
                    self.Factorys = res;
                    self.getPrevProductList()
                    self.getNextProductList()
                    // console.log(self.Images);
                });
        },
        handleClick(tab, event) {
            console.log(tab, event);
        },

    },
};
</script>
<style lang="scss" scoped>

/* 定义心跳跳动动画 */
@keyframes pulses {
    0% {
      transform: scale(1);
      opacity: 0.7;
    }

    50% {
      transform: scale(1.2);
      opacity: 1;
    }

    100% {
      transform: scale(1);
      opacity: 0.7;
    }
  }

@media screen and (min-width: 0px) and (max-width:440px) {
  .newDtail {
    width: 100%;
    overflow: hidden;
    margin: 0px auto;
    padding: 0px;

    .v-enter {
      opacity: 0;
      transform: translateY(150px);
    }

    .v-enter-active {
      transition: all 1s ease;
    }

    .contents {
      width: 100%;
      overflow: hidden;
      margin: 61px auto auto auto;
      padding-top: 20px;
      background: #ededed;

      .maincontent {
        width: 100%;
        overflow: hidden;
        margin: 0px auto;
        background: #fff;
        padding-bottom: 50px;

        .body {
          width: 100%;
          overflow: hidden;
          margin: 0px auto;
          padding: 30px 0px 0px 0px;
          box-sizing: border-box;

          .le {
            width: 90%;
            margin: 0px auto;
            box-sizing: border-box;
            overflow: hidden;
            .p-share {
              width: 100%;
              overflow: hidden;
              padding: 0px;
              font-weight: 600;
              box-sizing: border-box;
              padding-bottom: 30px;

              .share-t {
                width: 12%;
                overflow: hidden;
                margin: 0px auto;
                float: left;
                line-height: 28px;
                padding: 0px;
                display: flex;
                align-items: center;
                /* 水平居中，如果需要的话 */
                font-size: 20px;
                color: #252525;
              }
            }
            .p-con {
              width:198px;
              overflow: hidden;
              margin: 30px auto auto;
              padding: 0px;
              box-sizing: border-box;
              .p-b-s {
                width: 100%;
                overflow: hidden;
                padding: 0px;
                box-sizing: border-box;

                .p-ri:hover {
                  .arrow-text {
                    -webkit-transition: 0.6s ease-in-out;
                    transition: 0.6s ease-in-out;
                    float: right;
                    width: calc(100% - 100px);
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    color: #02999d;
                    text-align: center;
                    margin-top: 13.5px;

                  }

                  .arrow-le {
                    -webkit-transition: 0.6s ease-in-out;
                    transition: 0.6s ease-in-out;
                    background: url('~@/assets/img/right (1).png') no-repeat center #02999d;
                    width: 42px;
                    opacity: 0.9;
                    float: right;
                    height: 42px;
                    transform: skewX(-15deg);
                    background-size: 21px;
                  }
                }

                .p-ri {
                  width: 49%;
                  float: right;
                  overflow: hidden;
                  padding: 0px;
                  box-sizing: border-box;
                  cursor: pointer;
                  padding-right: 10px;
                  .arrow-texts{
                    color: #252525;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    text-align: center;
                    margin-top: 13.5px;
                  }

                  .arrow-text {
                    float: right;
                    width: calc(100% - 100px);
                    color: #252525;
                    white-space: nowrap;
                    display: none;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    text-align: center;
                    margin-top: 13.5px;

                  }

                  .arrow-le {
                    background: url('~@/assets/img/right (1).png') no-repeat center #252525;
                    width: 42px;
                    opacity: 0.9;
                    float: right;
                    height: 42px;
                    transform: skewX(-15deg);
                    background-size: 21px;
                  }
                }

                .p-le:hover {
                  .arrow-text {

                    -webkit-transition: 0.6s ease-in-out;
                    transition: 0.6s ease-in-out;
                    float: left;
                    width: calc(100% - 100px);
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    color: #02999d;
                    text-align: center;
                    margin-top: 13.5px;

                  }

                  .arrow-le {
                    -webkit-transition: 0.6s ease-in-out;
                    transition: 0.6s ease-in-out;
                    background: url('~@/assets/img/left.png') no-repeat center #02999d;
                    width: 42px;
                    opacity: 0.9;
                    float: left;
                    height: 42px;
                    transform: skewX(-15deg);
                    background-size: 21px;
                  }
                }

                .p-le {
                  width: 49%;
                  float: left;
                  cursor: pointer;
                  overflow: hidden;
                  padding: 0px;
                  position: relative;
                  box-sizing: border-box;
                  padding-left: 10px;

                  .line {
                    position: absolute;
                    top: 13.5px;
                    right: 0px;
                    width: 1px;
                    height: 20px;
                    background: #d9d9d9;
                    display: block;
                  }
                  .arrow-texts{
                    
                    -webkit-transition: 0.6s ease-in-out;
                    transition: 0.6s ease-in-out;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    color: #252525;
                    text-align: center;
                    margin-top: 13.5px;
                  }

                  .arrow-text {
                    float: left;
                    display: none;
                    -webkit-transition: 0.6s ease-in-out;
                    transition: 0.6s ease-in-out;
                    width: calc(100% - 100px);
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    color: #252525;
                    text-align: center;
                    margin-top: 13.5px;

                  }

                  .arrow-le {
                    -webkit-transition: 0.6s ease-in-out;
                    transition: 0.6s ease-in-out;
                    background: url('~@/assets/img/left.png') no-repeat center #252525;
                    width: 42px;
                    opacity: 0.9;
                    float: left;
                    height: 42px;
                    transform: skewX(-15deg);
                    background-size: 21px;
                  }
                }
              }
            }
          }

          .ri {
            width: calc(30% - 52px);
            margin: 0px auto;
            display: none;
            padding-left: 50px;
            float: right;
            border-left: 1px solid #d9d9d9;
            overflow: hidden;

            .slide-mores:hover {
              background: #02999d;
              border: 1px solid #02999d;
              color: #fff;
              -webkit-transition: 0.6s ease-in-out;
              transition: 0.6s ease-in-out;
            }

            .slide-mores {
              cursor: pointer;
              margin-top: 50px;
              margin-left: 12px;
              background: none;
              color: #252525;
              text-align: center;
              transform: skewX(-20deg);
              border: 1px solid #252525;
              width: 88px;
              font-size: 14px;
              line-height: 30px;

              .slide-more {
                transform: skewX(20deg);
              }
            }

            .hotnews {
              width: 100%;
              overflow: hidden;
              margin: 0px auto;
              padding: 0px;
              box-sizing: border-box;

              .items {
                width: 100%;
                margin: 0px auto;
                padding-top: 50px;
                padding-bottom: 50px;
                border-bottom: 1px solid #d9d9d9;
                box-sizing: border-box;
                overflow: hidden;

                .text {
                  color: #676767;
                  font-size: 16px;
                  margin-top: 25px;
                }

                .title {
                  font-size: 35px;
                  font-weight: 600;
                  color: #252525;
                  margin-top: 25px;
                }

                .times {
                  color: #00959b;
                  font-size: 18px;
                }
              }
            }

            .p-share {
              width: 100%;
              overflow: hidden;
              border-bottom: 1px solid #d9d9d9;
              padding: 0px;
              font-weight: 600;
              box-sizing: border-box;
              padding-bottom: 40px;

              .share-t {
                width: 15%;
                overflow: hidden;
                margin: 0px auto;
                float: left;
                line-height: 45px;
                padding: 0px;
                display: flex;
                align-items: center;
                /* 垂直居中 */
                justify-content: center;
                /* 水平居中，如果需要的话 */
                font-size: 25px;
                color: #252525;
                text-align: center;
              }

            }

          }

        }
      }

      .title-top {
        width: 90%;
        overflow: hidden;
        margin: 0px auto;
        font-size: 15px;
        padding: 0px;

        .title_text {
          font-weight: 600;
          color: #252525;
          margin: 15px auto 28px auto;
          font-size: 30px;
          width: 100%;
          overflow: hidden;
        }

        .title {
          width: 100%;
          overflow: hidden;
          margin: 0px auto;
          padding: 0px;
          box-sizing: border-box;
        }

        .views {
          float: left;
          color: #676767;
          display: block;
          background: url(../assets/img/views.png) no-repeat left;
          background-size: 15px;
          padding-left: 18px;
        }

        .admin {
          float: left;
          color: #676767;
          display: block;
          background: url(../assets/img/Admin.png) no-repeat left;
          background-size: 15px;
          padding-left: 18px;
          margin-right: 25px;
        }

        .line {
          float: left;
          margin-left: 25px;
          margin-right: 25px;
          font-weight: 400;
          color: #676767;
        }

        .time {
          float: left;
          font-size: 18px;
          color: #00959b;
        }
      }
    }
  }

}


@media screen and (min-width: 1024px) and (max-width:1600px) {
  .newDtail {
    width: 100%;
    overflow: hidden;
    margin: 0px auto;
    padding: 0px;

    .v-enter {
      opacity: 0;
      transform: translateY(150px);
    }

    .v-enter-active {
      transition: all 1s ease;
    }

    .contents {
      width: 100%;
      overflow: hidden;
      margin: 80px auto auto auto;
      padding-top: 90px;
      background: #ededed;

      .maincontent {
        width: 100%;
        overflow: hidden;
        margin: 0px auto;
        background: #fff;
        padding-bottom: 100px;

        .body {
          width: 1200px;
          overflow: hidden;
          margin: 0px auto;
          padding: 80px 0px 0px 0px;
          box-sizing: border-box;

          .le {
            width: 70%;
            margin: 0px auto;
            padding-right: 50px;
            box-sizing: border-box;
            float: left;
            overflow: hidden;
                
            .p-share {
               display: none
            }

            .p-con {
              width: 100%;
              overflow: hidden;
              margin: 50px auto auto;
              padding: 0px;
              box-sizing: border-box;
              .arrow-texts{
                display:none
              }

              .p-b-s {
                width: 100%;
                overflow: hidden;
                padding: 0px;
                box-sizing: border-box;

                .p-ri:hover {
                  .arrow-text {
                    -webkit-transition: 0.6s ease-in-out;
                    transition: 0.6s ease-in-out;
                    float: right;
                    width: calc(100% - 100px);
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    color: #02999d;
                    text-align: center;
                    margin-top: 13.5px;

                  }

                  .arrow-le {
                    -webkit-transition: 0.6s ease-in-out;
                    transition: 0.6s ease-in-out;
                    background: url('~@/assets/img/right (1).png') no-repeat center #02999d;
                    width: 42px;
                    opacity: 0.9;
                    float: right;
                    height: 42px;
                    transform: skewX(-15deg);
                    background-size: 21px;
                  }
                }

                .p-ri {
                  width: 49%;
                  float: right;
                  overflow: hidden;
                  padding: 0px;
                  box-sizing: border-box;
                  cursor: pointer;
                  padding-right: 10px;

                  .arrow-text {
                    float: right;
                    width: calc(100% - 100px);
                    color: #252525;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    text-align: center;
                    margin-top: 13.5px;

                  }

                  .arrow-le {
                    background: url('~@/assets/img/right (1).png') no-repeat center #252525;
                    width: 42px;
                    opacity: 0.9;
                    float: right;
                    height: 42px;
                    transform: skewX(-15deg);
                    background-size: 21px;
                  }
                }

                .p-le:hover {
                  .arrow-text {

                    -webkit-transition: 0.6s ease-in-out;
                    transition: 0.6s ease-in-out;
                    float: left;
                    width: calc(100% - 100px);
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    color: #02999d;
                    text-align: center;
                    margin-top: 13.5px;

                  }

                  .arrow-le {
                    -webkit-transition: 0.6s ease-in-out;
                    transition: 0.6s ease-in-out;
                    background: url('~@/assets/img/left.png') no-repeat center #02999d;
                    width: 42px;
                    opacity: 0.9;
                    float: left;
                    height: 42px;
                    transform: skewX(-15deg);
                    background-size: 21px;
                  }
                }

                .p-le {
                  width: 49%;
                  float: left;
                  cursor: pointer;
                  overflow: hidden;
                  padding: 0px;
                  position: relative;
                  box-sizing: border-box;
                  padding-left: 10px;

                  .line {
                    position: absolute;
                    top: 13.5px;
                    right: 0px;
                    width: 1px;
                    height: 20px;
                    background: #d9d9d9;
                    display: block;
                  }

                  .arrow-text {
                    float: left;
                    -webkit-transition: 0.6s ease-in-out;
                    transition: 0.6s ease-in-out;
                    width: calc(100% - 100px);
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    color: #252525;
                    text-align: center;
                    margin-top: 13.5px;

                  }

                  .arrow-le {
                    -webkit-transition: 0.6s ease-in-out;
                    transition: 0.6s ease-in-out;
                    background: url('~@/assets/img/left.png') no-repeat center #252525;
                    width: 42px;
                    opacity: 0.9;
                    float: left;
                    height: 42px;
                    transform: skewX(-15deg);
                    background-size: 21px;
                  }
                }
              }
            }
          }

          .ri {
            width: calc(30% - 52px);
            margin: 0px auto;
            padding-left: 50px;
            float: right;
            border-left: 1px solid #d9d9d9;
            overflow: hidden;

            .slide-mores:hover {
              background: #02999d;
              border: 1px solid #02999d;
              color: #fff;
              -webkit-transition: 0.6s ease-in-out;
              transition: 0.6s ease-in-out;
            }

            .slide-mores {
              cursor: pointer;
              margin-top: 50px;
              margin-left: 12px;
              background: none;
              color: #252525;
              text-align: center;
              transform: skewX(-20deg);
              border: 1px solid #252525;
              width: 88px;
              font-size: 14px;
              line-height: 30px;

              .slide-more {
                transform: skewX(20deg);
              }
            }

            .hotnews {
              width: 100%;
              overflow: hidden;
              margin: 0px auto;
              padding: 0px;
              box-sizing: border-box;

              .items {
                width: 100%;
                margin: 0px auto;
                padding-top: 50px;
                padding-bottom: 50px;
                border-bottom: 1px solid #d9d9d9;
                box-sizing: border-box;
                overflow: hidden;

                .text {
                  color: #676767;
                  font-size: 16px;
                  margin-top: 25px;
                }

                .title {
                  font-size: 35px;
                  font-weight: 600;
                  color: #252525;
                  margin-top: 25px;
                }

                .times {
                  color: #00959b;
                  font-size: 18px;
                }
              }
            }

            .p-share {
              width: 100%;
              overflow: hidden;
              border-bottom: 1px solid #d9d9d9;
              padding-top: 10px;
              font-weight: 600;
              box-sizing: border-box;
              padding-bottom: 40px;

              .share-t:hover {
                -webkit-transition: 0.8s ease-in-out;
                transition: 0.8s ease-in-out;
                animation: pulses 2s infinite;
              }

              .share-t {
                width: 14%;
                overflow: hidden;
                cursor: pointer;
                margin: 0px auto;
                float: left;
                line-height: 45px;
                padding: 0px;
                display: flex;
                align-items: center;
                /* 垂直居中 */
                justify-content: center;
                /* 水平居中，如果需要的话 */
                font-size: 25px;
                color: #252525;
                text-align: center;
              }

            }

          }

        }
      }

      .title-top {
        width: 1200px;
        overflow: hidden;
        margin: 0px auto;
        font-size: 15px;
        padding: 0px;

        .title_text {
          font-weight: 600;
          color: #252525;
          font-size: 35px;
          margin-top: 25px;
          width: 100%;
          overflow: hidden;
          margin-bottom: 80px;
        }

        .title {
          width: 100%;
          overflow: hidden;
          margin: 0px auto;
          padding: 0px;
          box-sizing: border-box;
        }

        .views {
          float: left;
          color: #676767;
          display: block;
          background: url(../assets/img/views.png) no-repeat left;
          background-size: 15px;
          padding-left: 18px;
        }

        .admin {
          float: left;
          color: #676767;
          display: block;
          background: url(../assets/img/Admin.png) no-repeat left;
          background-size: 15px;
          padding-left: 18px;
          margin-right: 25px;
        }

        .line {
          float: left;
          margin-left: 25px;
          margin-right: 25px;
          font-weight: 400;
          color: #676767;
        }

        .time {
          float: left;
          font-size: 18px;
          color: #00959b;
        }
      }
    }
  }


}


@media screen and (min-width: 1601px) and (max-width:8000px) {
  .newDtail {
    width: 100%;
    overflow: hidden;
    margin: 0px auto;
    padding: 0px;

    .v-enter {
      opacity: 0;
      transform: translateY(150px);
    }

    .v-enter-active {
      transition: all 1s ease;
    }

    .contents {
      width: 100%;
      overflow: hidden;
      margin: 80px auto auto auto;
      padding-top: 90px;
      background: #ededed;

      .maincontent {
        width: 100%;
        overflow: hidden;
        margin: 0px auto;
        background: #fff;
        padding-bottom: 100px;

        .body {
          width: 1600px;
          overflow: hidden;
          margin: 0px auto;
          padding: 80px 0px 0px 0px;
          box-sizing: border-box;

          .le {
            width: 70%;
            margin: 0px auto;
            padding-right: 50px;
            box-sizing: border-box;
            float: left;
            overflow: hidden;
                
            .p-share {
               display: none
            }

            .p-con {
              width: 100%;
              overflow: hidden;
              margin: 50px auto auto;
              padding: 0px;
              box-sizing: border-box;
              .arrow-texts{
                display:none
              }

              .p-b-s {
                width: 100%;
                overflow: hidden;
                padding: 0px;
                box-sizing: border-box;

                .p-ri:hover {
                  .arrow-text {
                    -webkit-transition: 0.6s ease-in-out;
                    transition: 0.6s ease-in-out;
                    float: right;
                    width: calc(100% - 100px);
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    color: #02999d;
                    text-align: center;
                    margin-top: 13.5px;

                  }

                  .arrow-le {
                    -webkit-transition: 0.6s ease-in-out;
                    transition: 0.6s ease-in-out;
                    background: url('~@/assets/img/right (1).png') no-repeat center #02999d;
                    width: 42px;
                    opacity: 0.9;
                    float: right;
                    height: 42px;
                    transform: skewX(-15deg);
                    background-size: 21px;
                  }
                }

                .p-ri {
                  width: 49%;
                  float: right;
                  overflow: hidden;
                  padding: 0px;
                  box-sizing: border-box;
                  cursor: pointer;
                  padding-right: 10px;

                  .arrow-text {
                    float: right;
                    width: calc(100% - 100px);
                    color: #252525;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    text-align: center;
                    margin-top: 13.5px;

                  }

                  .arrow-le {
                    background: url('~@/assets/img/right (1).png') no-repeat center #252525;
                    width: 42px;
                    opacity: 0.9;
                    float: right;
                    height: 42px;
                    transform: skewX(-15deg);
                    background-size: 21px;
                  }
                }

                .p-le:hover {
                  .arrow-text {

                    -webkit-transition: 0.6s ease-in-out;
                    transition: 0.6s ease-in-out;
                    float: left;
                    width: calc(100% - 100px);
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    color: #02999d;
                    text-align: center;
                    margin-top: 13.5px;

                  }

                  .arrow-le {
                    -webkit-transition: 0.6s ease-in-out;
                    transition: 0.6s ease-in-out;
                    background: url('~@/assets/img/left.png') no-repeat center #02999d;
                    width: 42px;
                    opacity: 0.9;
                    float: left;
                    height: 42px;
                    transform: skewX(-15deg);
                    background-size: 21px;
                  }
                }

                .p-le {
                  width: 49%;
                  float: left;
                  cursor: pointer;
                  overflow: hidden;
                  padding: 0px;
                  position: relative;
                  box-sizing: border-box;
                  padding-left: 10px;

                  .line {
                    position: absolute;
                    top: 13.5px;
                    right: 0px;
                    width: 1px;
                    height: 20px;
                    background: #d9d9d9;
                    display: block;
                  }

                  .arrow-text {
                    float: left;
                    -webkit-transition: 0.6s ease-in-out;
                    transition: 0.6s ease-in-out;
                    width: calc(100% - 100px);
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    color: #252525;
                    text-align: center;
                    margin-top: 13.5px;

                  }

                  .arrow-le {
                    -webkit-transition: 0.6s ease-in-out;
                    transition: 0.6s ease-in-out;
                    background: url('~@/assets/img/left.png') no-repeat center #252525;
                    width: 42px;
                    opacity: 0.9;
                    float: left;
                    height: 42px;
                    transform: skewX(-15deg);
                    background-size: 21px;
                  }
                }
              }
            }
          }

          .ri {
            width: calc(30% - 52px);
            margin: 0px auto;
            padding-left: 50px;
            float: right;
            border-left: 1px solid #d9d9d9;
            overflow: hidden;

            .slide-mores:hover {
              background: #02999d;
              border: 1px solid #02999d;
              color: #fff;
              -webkit-transition: 0.6s ease-in-out;
              transition: 0.6s ease-in-out;
            }

            .slide-mores {
              cursor: pointer;
              margin-top: 50px;
              margin-left: 12px;
              background: none;
              color: #252525;
              text-align: center;
              transform: skewX(-20deg);
              border: 1px solid #252525;
              width: 88px;
              font-size: 14px;
              line-height: 30px;

              .slide-more {
                transform: skewX(20deg);
              }
            }

            .hotnews {
              width: 100%;
              overflow: hidden;
              margin: 0px auto;
              padding: 0px;
              box-sizing: border-box;

              .items {
                width: 100%;
                margin: 0px auto;
                padding-top: 50px;
                padding-bottom: 50px;
                border-bottom: 1px solid #d9d9d9;
                box-sizing: border-box;
                overflow: hidden;

                .text {
                  color: #676767;
                  font-size: 16px;
                  margin-top: 25px;
                }

                .title {
                  font-size: 35px;
                  font-weight: 600;
                  color: #252525;
                  margin-top: 25px;
                }

                .times {
                  color: #00959b;
                  font-size: 18px;
                }
              }
            }

            .p-share {
              width: 100%;
              overflow: hidden;
              border-bottom: 1px solid #d9d9d9;
              padding-top: 10px;
              font-weight: 600;
              box-sizing: border-box;
              padding-bottom: 40px;

              .share-t:hover {
                -webkit-transition: 0.8s ease-in-out;
                transition: 0.8s ease-in-out;
                animation: pulses 2s infinite;
              }

              .share-t {
                width: 15%;
                overflow: hidden;
                cursor: pointer;
                margin: 0px auto;
                float: left;
                line-height: 45px;
                padding: 0px;
                display: flex;
                align-items: center;
                /* 垂直居中 */
                justify-content: center;
                /* 水平居中，如果需要的话 */
                font-size: 25px;
                color: #252525;
                text-align: center;
              }

            }

          }

        }
      }

      .title-top {
        width: 1600px;
        overflow: hidden;
        margin: 0px auto;
        font-size: 15px;
        padding: 0px;

        .title_text {
          font-weight: 600;
          color: #252525;
          font-size: 35px;
          margin-top: 25px;
          width: 100%;
          overflow: hidden;
          margin-bottom: 80px;
        }

        .title {
          width: 100%;
          overflow: hidden;
          margin: 0px auto;
          padding: 0px;
          box-sizing: border-box;
        }

        .views {
          float: left;
          color: #676767;
          display: block;
          background: url(../assets/img/views.png) no-repeat left;
          background-size: 15px;
          padding-left: 18px;
        }

        .admin {
          float: left;
          color: #676767;
          display: block;
          background: url(../assets/img/Admin.png) no-repeat left;
          background-size: 15px;
          padding-left: 18px;
          margin-right: 25px;
        }

        .line {
          float: left;
          margin-left: 25px;
          margin-right: 25px;
          font-weight: 400;
          color: #676767;
        }

        .time {
          float: left;
          font-size: 18px;
          color: #00959b;
        }
      }
    }
  }
}
</style>